import {
  getAssociatedCourses,
  getAdminAssociatedCourses,
} from './GetAssociatedCourses'

export const certificatesCoursesService = {
  getAssociatedCourses,
  getAdminAssociatedCourses,
}
